module.exports = __webpack_public_path__ + "static/21-07-15_17-50-12_6604-1822a59557c85426816b5570059cf3c6.jpg";